<ui-dialog
    [open]="isJourneyDialogOpen"
    [isCloseable]="true"
    size="small"
    header="employees.journey.addJourneyItem"
    (primaryButtonPressed)="onCreate(journeyForm.journey, journeyForm)"
    primaryButtonLabel="{{ 'save' | appTranslate }}"
    secondaryButtonLabel="{{ 'cancel' | appTranslate }}"
    [secondaryButtonType]="'ghost'"
    (closing)="closeJourneyDialog()"
    [form]="journeyForm.form"
>
    <app-form-journey #journeyForm></app-form-journey>
</ui-dialog>

<app-deprecated-confirmation-dialog
    #confirmDeleteDialog
    [label]="'delete'"
    [negative]="true"
    [description]="'account.journey.deleteConfirmationMessage'"
>
</app-deprecated-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-employee-header [employee]="employee" (isLoading)="isLoading = $event">
        <div class="buttons">
            <ui-button type="primary" (click)="openJourneyDialog()" *permission="'invite.account'">
                <mat-icon svgIcon="plus"></mat-icon>{{ 'employees.journey.createJourneyItem' | appTranslate }}
            </ui-button>
        </div>
    </app-employee-header>

    <div class="ui layout">
        <div class="sidebar">
            <app-profile-card [model]="employee"></app-profile-card>
        </div>
        <div class="content">
            <div class="ui segment">
                <app-segment-header title="employees.journey.employmentJourney"></app-segment-header>

                <div class="journey-container">
                    <div class="journey-row" *ngFor="let item of journey; let last = last">
                        <div class="journey-image">
                            <span *ngIf="item.type === 'hire'">
                                <i class="fal fa-handshake fa-2x" aria-hidden="true"></i>
                            </span>
                            <span *ngIf="item.type === 'termination'">
                                <i class="fal fa-times-circle fa-2x" aria-hidden="true"></i>
                            </span>
                            <span *ngIf="item.type === 'payroll'">
                                <i class="fal fa-money-bill fa-2x" aria-hidden="true"></i>
                            </span>
                            <span *ngIf="item.type === 'address'">
                                <i class="fal fa-home fa-2x" aria-hidden="true"></i>
                            </span>
                            <span *ngIf="item.type === 'leave_start'">
                                <mat-icon svgIcon="handRaisesStop"></mat-icon>
                            </span>
                            <span *ngIf="item.type === 'leave_end'">
                                <mat-icon svgIcon="calendarSuccess"></mat-icon>
                            </span>
                            <span *ngIf="item.type === 'employee' || item.type === 'other'">
                                <i class="fal fa-user fa-2x" aria-hidden="true"></i>
                            </span>
                        </div>

                        <div class="journey-title">{{ item.title }}</div>

                        <div class="journey-message" [innerHTML]="item.message | sanitizeHtml"></div>

                        <div class="journey-date">
                            <ng-container *ngIf="item.endDate; else startOnly">
                                {{ item.date | appDate: 'mediumDate' }} {{ 'to' | appTranslate | lowercase }}
                                {{ item.endDate | appDate: 'mediumDate' }} &nbsp;
                            </ng-container>
                            <ng-template #startOnly>{{ item.date | appDate: 'mediumDate' }} &nbsp;</ng-template>
                            <ng-container *ngIf="!last && userCanDelete && item.isPersisted">
                                <i (click)="onDelete(item)" class="journey-delete fal fa-trash" aria-hidden="true"></i>
                            </ng-container>
                        </div>

                        <div *ngIf="!last" class="journey-spacer">
                            <div class="journey-line"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
